export default __webpack_public_path__ + "static/media/3.54dad34c.png";